module.exports = __webpack_public_path__ + "iceland.svg?0a5414662771ff333d25c42d0e5dd2b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/iceland.svg
// module id = 189
// module chunks = 10